/**
 * @generated SignedSource<<a481b396b493b6dea44497143387a4af>>
 * @relayHash 478833aa4fef1b1eef2a699ca49af9e4
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 478833aa4fef1b1eef2a699ca49af9e4

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AllowTakeOverPatientFileLockInput = {
  inboundCallId?: number | null;
  patientId: string;
};
export type useAllowTakeOverPatientMutation$variables = {
  input: AllowTakeOverPatientFileLockInput;
};
export type useAllowTakeOverPatientMutation$data = {
  readonly allowTakeOverPatientFileLock: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly patientFileLockOutput: {
      readonly " $fragmentSpreads": FragmentRefs<"PatientFileLockOutputFragment">;
    } | null;
  };
};
export type useAllowTakeOverPatientMutation = {
  response: useAllowTakeOverPatientMutation$data;
  variables: useAllowTakeOverPatientMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAllowTakeOverPatientMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "AllowTakeOverPatientFileLockPayload",
        "kind": "LinkedField",
        "name": "allowTakeOverPatientFileLock",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientFileLockOutput",
            "kind": "LinkedField",
            "name": "patientFileLockOutput",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PatientFileLockOutputFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useAllowTakeOverPatientMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "AllowTakeOverPatientFileLockPayload",
        "kind": "LinkedField",
        "name": "allowTakeOverPatientFileLock",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientFileLockOutput",
            "kind": "LinkedField",
            "name": "patientFileLockOutput",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PatientFileLock",
                "kind": "LinkedField",
                "name": "patientFileLock",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "patientId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lockedBy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lockedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lockRequestedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lockRequestedBy",
                    "storageKey": null
                  },
                  {
                    "alias": "inContextOfAppointment",
                    "args": null,
                    "concreteType": "Appointment",
                    "kind": "LinkedField",
                    "name": "appointment",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requestInContextOfAppointmentId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Appointment",
                "kind": "LinkedField",
                "name": "inContextOfAppointment",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCompleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppointmentChatDetails",
                    "kind": "LinkedField",
                    "name": "chatDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "chatThreadId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "478833aa4fef1b1eef2a699ca49af9e4",
    "metadata": {},
    "name": "useAllowTakeOverPatientMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "919e948ba85503c5a17ccc00d877f8f8";

export default node;
